import React from 'react';
import PropTypes from "prop-types";
import moment from "moment";

import {DEFAULT_DATE_FORMAT} from "../../constants/dates";

function LessonDropdownItem({item}) {
    return (
        <div>
            <div className="autocomplete-dropdown-menu-item-title">{item.code}</div>
            <div className="autocomplete-dropdown-menu-item-second">{item.name}</div>
            <div
                className="autocomplete-dropdown-menu-item-second">{moment(item.created_at * 1000).format(DEFAULT_DATE_FORMAT)}</div>
        </div>
    );
}

LessonDropdownItem.propTypes = {
    item: PropTypes.shape({
        name: PropTypes.string.isRequired,
        code: PropTypes.string.isRequired,
        created_at: PropTypes.number.isRequired
    }).isRequired
};

export default LessonDropdownItem;
